import moment from 'moment-timezone';
import { Icons } from './Constants';
import {DOMAIN_READ_ONLY, LINE_BREAK_CODE, listOfProducts} from '../app/shared/constants/Constants';
import 'moment/locale/es';

export function getIcon(type) {
  if (Icons[type] !== undefined) {
    return Icons[type].url;
  }
  return Icons.default.url;
}

export function isOnlyReaderToDomain(mail) {
  const dominio = mail.split('@');
  let isReadOnly = false;
  if (dominio.length > 1) {
    if (dominio[1] === DOMAIN_READ_ONLY) {
      isReadOnly = true;
    }
  }
  return isReadOnly;
}

export function removeDays(date, days) {
  date = new Date(date);
  date.setDate(date.getDate() - days);
  return date;
};


export function findByAtribute(list = [], property, valueDefaul) {
  let value = valueDefaul || '-';
  const index = list.findIndex((value) => {
    return value.Name === property;
  });

  if (index !== -1) {
    value = list[index].Value;
  }
  return value;
}

export function removeElementFromArray(index, arr) {
  const position = arr.findIndex((a, i) => i === index);
  if (position > -1) {
    arr.splice(position, 1);
  }
  return arr;
}

export function getTypeDocument(document) {
  let typeDocument = 'DNI';

  switch (document) {
    case 'l':
      typeDocument = 'DNI';
      break;
    case 'r':
      typeDocument = 'RUC';
      break;
    case 'e':
      typeDocument = 'carné extranjería';
      break;
    default:
      typeDocument = 'DNI';
  }
  return typeDocument;
}

export function formatDate(date, format = 'DD/MM/YYYY') {
  let dateFormat = '';
  if (date) {
    dateFormat = moment(date).format(format);
  }
  return dateFormat;
}

export function swapMonthsDay (value){
  value = value.split("/");
  return new Date(value[2], parseInt(value[1], 10)-1, value[0]);
}

export  function getPdp(value){
  let valueReturn = "Si";

  if(value==='false'){
    valueReturn = "No";
  }
  return valueReturn;
}

export function isEmpty(value) {
  return value === '';
}

export function inspectParagraph(paragraphs) {
  if(paragraphs.length > 0 ){
    return paragraphs.map((p) => {
      if(p.hasOwnProperty('paragraph') && p.paragraph.includes(LINE_BREAK_CODE)){
        p.paragraph = p.paragraph.replace(/\n/g, '<br>');
      }
      return p;
    })
  }
  return paragraphs;
}
export function inspectParagraphInverse(paragraphs) {
  if(paragraphs.length > 0 ){
    return paragraphs.map((p) => {
      if(p.hasOwnProperty('paragraph') && p.paragraph.includes('<br>')){
        p.paragraph = p.paragraph.replaceAll('<br>', LINE_BREAK_CODE);
      }
      return p;
    })
  }
  return paragraphs;
}

export function isEmptyArray(arr) {
  return arr.length === 0;
}

export function capitalize(text){
  let wordsArray = text.toLowerCase().split(' ')
  let capsArray = wordsArray.map(word=>{
    return word[0].toUpperCase() + word.slice(1)
  })
  return capsArray.join(' ');
}

export function getMessageField(field) {
  let message = '';
  switch (field) {
    case 'principalTitle':
      message = 'Título Principal';
      break;
    case 's3UrlImage':
      message = 'Imagen del Boletín';
      break;
    case 'urlLink':
      message = 'Archivo';
      break;
    default:
      message = 'Título Principal';
  }
  return message;
}

export function isRequired(atributes = [], data = {}) {
  if (atributes) {
    const message = [];
    atributes.forEach((a) => {
      if (data.hasOwnProperty(a) && data[a] === '') {
        const field = getMessageField(a);
        message.push(`${field} es obligatorio ` + '    ');
      } else if (a === 'urlLink') {
        const { buttons } = data;
        if (isEmpty(buttons[0].link)) {
          message.push(`    El enlace es obligatorio   `);
        }
      }
    });
    return message;
  }
  return null;
}

export function getStructToGetUrlFile(categoryId, fileName) {
  const date = new Date();
  return btoa(`${categoryId}#${date.getFullYear()}-${date.getMonth() + 1}#${fileName}`);
}

export function transformDatetoUnix(date) {
  if (date) {
    return moment(date).format('X');
  }
  return null;
}

export function removeDuplicates(originalArray, prop) {
  const newArray = [];
  const lookupObject = {};

  for (const i in originalArray) {
    lookupObject[originalArray[i][prop]] = originalArray[i];
  }

  for (const i in lookupObject) {
    newArray.push(lookupObject[i]);
  }
  return newArray;
}

export function removeElement(value, array) {
  return array.filter((ar) => {
    return ar.branchId !== value;
  });
}

export function generateArrayIterable(count){
  return Array.from({ length: count }, (_, i) => i + 1);
}

export function setProducts(products) {
  let prod = products.map((p) => {
    if (p.branchId === 71 && p.productDescription.trim().toUpperCase() === 'AT') {
      return { ...p, ...listOfProducts[`${p.branchId}2`] };
    }
    return { ...p, ...listOfProducts[p.branchId] };
  });

  prod = prod.filter((ar) => {
    //return ar.icon !== undefined && ar.status === 'Vigente';
    return ar.icon !== undefined;
  });
  prod = removeDuplicates(prod, 'branchId');
  prod = removeElement(72, prod);
  return prod;
}

export function capitalizeSentence(s) {
  return s.toLowerCase().replace( /\b./g, function(a){ return a.toUpperCase(); } );
}

export function getMes(numberMonth) {
  let month = ""
  switch (numberMonth) {
    case '01':
      month = "Enero";
      break;
    case '02':
      month = "Febrero";
      break;
    case '03':
      month = "Marzo";
      break;
    case '04':
      month = "Abril";
      break;
    case '05':
      month = "Mayo";
      break;
    case '06':
      month = "Junio";
      break;
    case '07':
      month = "Julio";
      break;
    case '08':
      month = "Agosto";
      break;
    case '09':
      month = "Setiembre";
      break;
    case '10':
      month = "Octubre";
      break;
    case '11':
      month = "Noviembre";
      break;
    case '12':
      month = "Diciembre";
      break;
    default:
      month = "-";
  }
  return  month

}

export function getCurrentYear() {
  const date = new Date();
  return date.getFullYear();
}

export function getLastThreeYear() {
  const listYear = [];
  const year = getCurrentYear();
  listYear.push(
    { value: year, label: year },
    { value: year - 1, label: year - 1 },
    { value: year - 2, label: year - 2 }
  );
  return listYear;
}

export function base64toBlob(base64Data, contentType) {
  contentType = contentType || '';
  const sliceSize = 1024;
  const byteCharacters = atob(base64Data);
  const bytesLength = byteCharacters.length;
  const slicesCount = Math.ceil(bytesLength / sliceSize);
  const byteArrays = new Array(slicesCount);

  for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
    const begin = sliceIndex * sliceSize;
    const end = Math.min(begin + sliceSize, bytesLength);

    const bytes = new Array(end - begin);
    for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
      bytes[i] = byteCharacters[offset].charCodeAt(0);
    }
    byteArrays[sliceIndex] = new Uint8Array(bytes);
  }
  return new Blob(byteArrays, { type: contentType });
}


export function fixStructBase64(base64Data) {
  let base64Clear = '';
  const base64Split = base64Data.split(",");


  if(base64Split.length>0){
    base64Clear = base64Split[1];
    const lastCharacter = '"';
    if( base64Split[1].substring( base64Split[1].length - 1) === lastCharacter){

      base64Clear = base64Split[1].substring(0,base64Split[1].length - 1);
    }
  }
  return base64Clear;
}

export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}


export function maxLengthCheck(evt) {
  const theEvent = evt || window.event;
  let key;
  // Handle paste          onKeyPress={(e) => maxLengthCheck(e)}
  if (theEvent.type === 'paste') {
    key = evt.clipboardData.getData('text/plain');
  } else {
    // Handle key press
    key = theEvent.keyCode || theEvent.which;
    key = String.fromCharCode(key);
  }
  const regex = /[0-9]|\./;
  if (!regex.test(key)) {
    theEvent.returnValue = false;
    if (theEvent.preventDefault) theEvent.preventDefault();
  }
}

export function mapToSelect(options, propertyId, propertyLabel) {
  const optionsReturn = options.map((option) => {
    return { ...option, value: option[propertyId], label: option[propertyLabel] };
  });
  optionsReturn.unshift({ value: '', label: 'Seleccione' });
  return optionsReturn;
}
